import Axios from 'axios';
import {
  Toast,
  getDouyinData,
  getWxData,
  uploadLogFile,
  setToken,
  getToken,
  formatLogTime,
  confirmModal,
  createId
} from './common';
import { baseURL, platform, isDev } from './config';
import { logger } from './logger';
import processRequestData from './processRequestData';
import Store from './Store';

const lang = 'zh';

function checkIfNeedWriteLog(url) {
  return [
    'v5/media/upload',
    'v5/media/upload/base64',
    'v5/image/upload',
    'v5/image/upload/base64',
    'v5/image/segment/url',
    'v5/image/crop/alpha'
  ].filter((v) => url.indexOf(v) > -1 || v.indexOf(url) > -1).length;
}

function n(fn) {
  try {
    fn();
  } catch (error) {
    console.error(error);
    // 处理错误
  }
}

Axios.defaults.withCredentials = true;
var instance = Axios.create({
  baseURL,
  timeout: 60 * 1000,
  withCredentials: false,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

let timeoutList = ['ECONNABORTED', 'timeout'];

function isTimeoutError(errMsg) {
  try {
    if (
      timeoutList.filter(
        (v) => v.indexOf(errMsg) > -1 || errMsg.indexOf(v) > -1
      ).length
    ) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}

let errorConfig = {};
instance.interceptors.request.use(
  (config) => {
    n(() => {
      config.metadata = {
        startTime: Date.now()
      };
    });

    if (!config.url.match(/lang=/g)) {
      if (!config.url.match(/\?/g)) {
        config.url += '?lang=' + lang;
      } else {
        config.url += '&lang=' + lang;
      }
    }
    let deviceId = Store.get('deviceId') || '';
    if (!deviceId) {
      deviceId = createId(32);
      Store.set('deviceId', deviceId);
    }
    if (!config.url.match(/deviceId=/g)) {
      if (!config.url.match(/\?/g)) {
        config.url += '?deviceId=' + deviceId;
      } else {
        config.url += '&deviceId=' + deviceId;
      }
    }
    config.headers.token = getToken();
    let dyData = getDouyinData();
    let wxData = getWxData();
    let newPlatform = platform;
    if (dyData && dyData.platform) {
      newPlatform = dyData.platform;
    } else if (wxData && wxData.platform) {
      newPlatform = wxData.platform;
    } else {
      let arr = location.href.match(/&platform=(.*)&?/);
      if (arr && arr[1] && typeof parseInt(arr[1]) == 'number') {
        newPlatform = parseInt(arr[1]);
      }
    }
    if (!config.url.match(/platform=/g)) {
      if (!config.url.match(/\?/g)) {
        config.url += '?platform=' + newPlatform;
      } else {
        config.url += '&platform=' + newPlatform;
      }
    }
    if (!config.url.match(/timestamp=/g)) {
      let timestamp = +new Date();
      if (!config.url.match(/\?/g)) {
        config.url += '?timestamp=' + timestamp;
      } else {
        config.url += '&timestamp=' + timestamp;
      }
    }
    errorConfig = {
      url: config.url,
      data: config.data
    };
    // 在发送请求之前做些什么
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

const reportApiList = [
  'v5/media/upload',
  'v5/image/upload',
  'v5/image/segment/url'
];

instance.interceptors.response.use((data) => {
  n(() => {
    if (checkIfNeedWriteLog(data.config.url)) {
      const duration = Math.round(
        (Date.now() - data.config.metadata.startTime) / 1000
      );
      // logger.info(`接口url=${data.config.url} 耗时: ${duration}s`);
      try {
        window.report &&
          window.report(`api_${data.config.url.split('?')[0]}`, {
            time: formatLogTime(Date.now() - data.config.metadata.startTime)
          });
      } catch (error) {
        console.log(error);
      }
    }
  });

  if (data.config.disableErrorToast) {
    data.disableErrorToast = true;
    data.data && (data.data.disableErrorToast = true);
  }
  if (data.status == 200 && data.data && !data.data.error) {
    n(() => {
      try {
        let url, hash;
        try {
          url = data.config.url.split('?')[0];
          hash = location.hash.split('?')[0];
        } catch (error) {}
        if ([0, 1001].indexOf(data.data.code) == -1) {
          logger.info(
            `[${hash}]:报错,url=${url},req=${JSON.stringify(
              processRequestData(data.config.data)
            )},res=${JSON.stringify(data.data)}`
          );
        } else {
          let report = false;
          reportApiList.forEach((v) => {
            if (data.config.url.indexOf(v) > -1) {
              report = true;
            }
          });
          let reqData = `req=${JSON.stringify(
            processRequestData(data.config.data)
          )}`;

          let ignoreReqUrlList = ['/v5/image/upload', '/v5/media/upload'];
          if (ignoreReqUrlList.some((v) => data.config.url.indexOf(v) > -1)) {
            reqData = '';
          }
          report &&
            logger.info(
              `[${hash}]:url=${url},${reqData},res=${JSON.stringify(data.data)}`
            );
        }
      } catch (error) {
        console.error(error);
        // 处理错误
      }
    });
    return data.data;
  } else {
    logger.info(`接口报错,response=${JSON.stringify(data)}`);
    return Promise.reject(data);
  }
});

let whiteList = [];
instance.interceptors.response.use((res) => {
  return new Promise((resolve, reject) => {
    if (res.code == 0) {
      resolve(res.data);
    } else if (res.code == 1000) {
      reject(res.data);
      errorConfig.res = res;
    } else if (res.code == 403) {
      window.report && window.report('token_invalid');
      logger.info('登录信息失效');
      setToken('');
      if (Store.getSession('isOid') == 1) {
        Toast('登录信息失效,退出重试');
      } else {
        let dyData = getDouyinData();
        let wxData = getWxData();
        let isDouyinApp = dyData && dyData.orderNo;
        let isWx =
          location.href.indexOf('isFromMiniApp') > -1 &&
          window.wx &&
          window.wx.miniProgram;
        let sdk = isDouyinApp ? window.tt : window.wx;
        if (isWx || isDouyinApp || wxData) {
          sdk.miniProgram.postMessage({
            data: {
              type: 'reLogin'
            }
          });
          sdk.miniProgram.navigateBack();
        } else {
          location.href = location.origin;
          window.report &&
            window.report('error', {
              reason: 'code=403'
            });
        }
      }
    } else if (whiteList.indexOf(res.code) > -1) {
      resolve(res);
    } else {
      reject(res);
      errorConfig.res = res;
    }
  })
    .then((res) => {
      errorConfig = {};
      return res;
    })
    .catch(async (err) => {
      // logger.error('请求错误errorConfig', errorConfig);
      // logger.error(err);
      if (err && err.code) {
        if (err.code != 1001 && err.code !== 1009 && !err.disableErrorToast) {
          Toast(`连接超时,code=${err.code}`);
          //
        }
        if (err.code == 2000) {
          uploadLogFile(true);
        }
      } else if (typeof err === 'string') {
        if (isTimeoutError(err)) {
          await confirmModal({
            content: '网络连接超时，请检查网络环境后重试(关闭VPN或代理)',
            showCancel: false,
            confirmText: '确定'
          });
        } else {
          Toast(err);
        }
      }
      throw err;
    });
});

export default instance;
